import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
});

export interface AvailabilityRule {
  _id: string;
  itemType?: "NowMeal" | "NowCombo";
  mealId: {
    _id: string;
    name?: string;
    title?: string;
    image?: string;
    categoryId?: { _id: string; name: string };
    currentPrice?: number;
    comboPrice?: number;
    mrp?: number;
    isActive?: boolean;
    items?: any[];
  };
  kitchenId?: { _id: string; name: string } | null;
  ruleName: string;
  isActive: boolean;
  scheduleType: "WEEKLY" | "SPECIFIC_DATES" | "DATE_RANGE";
  daysOfWeek: number[];
  specificDates: string[];
  startDate: string | null;
  endDate: string | null;
  stockMode: "LIMITED" | "UNLIMITED";
  defaultQuantity: number;
  dayQuantities: Record<string, number>;
  priority: number;
  createdAt?: string;
  updatedAt?: string;
}

export const availabilityRulesApi = {
  getRules: async (filters: { mealId?: string; scheduleType?: string; isActive?: boolean; itemType?: string } = {}) => {
    let url = `${API_URL}/api/admin/availability-rules?`;
    if (filters.mealId) url += `&mealId=${encodeURIComponent(filters.mealId)}`;
    if (filters.scheduleType) url += `&scheduleType=${encodeURIComponent(filters.scheduleType)}`;
    if (filters.isActive !== undefined) url += `&isActive=${filters.isActive}`;
    if (filters.itemType) url += `&itemType=${encodeURIComponent(filters.itemType)}`;

    const response = await axios.get(url, { headers: getAuthHeaders() });
    return response.data;
  },

  getRuleById: async (id: string) => {
    const response = await axios.get(`${API_URL}/api/admin/availability-rules/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  createRule: async (data: any) => {
    const response = await axios.post(`${API_URL}/api/admin/availability-rules`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  updateRule: async (id: string, data: Partial<AvailabilityRule>) => {
    const response = await axios.put(`${API_URL}/api/admin/availability-rules/${id}`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  toggleRule: async (id: string) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/availability-rules/${id}/toggle`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  deleteRule: async (id: string) => {
    const response = await axios.delete(`${API_URL}/api/admin/availability-rules/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};
